"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisplayEntity = exports.AudienceStatDto = void 0;
const swagger_1 = require("@nestjs/swagger");
const dto_1 = require("../../../dto");
const types_1 = require("../../../types");
const user_entity_1 = require("../../user/user.entity");
const display_category_entity_1 = require("../category/display-category.entity");
const tag_1 = require("../tag");
const display_group_entity_1 = require("./display-group.entity");
class AudienceStatDto {
    day_of_week; // 0=Dom, 1=Lun ... 7=Todos/Promedio
    hours;
    daily_total; // Total diario pre-calculado para búsquedas rápidas
}
exports.AudienceStatDto = AudienceStatDto;
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Day of the week (0=Sun, 1=Mon ... 7=All/Average)",
        example: 1,
    }),
    __metadata("design:type", Number)
], AudienceStatDto.prototype, "day_of_week", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Hourly audience statistics",
        type: "array",
        items: {
            type: "object",
            properties: {
                start: {
                    type: "number",
                    example: 28800,
                    description: "Start time in seconds (e.g., 28800 for 08:00)",
                },
                end: {
                    type: "number",
                    example: 36000,
                    description: "End time in seconds (e.g., 36000 for 10:00)",
                },
                count: { type: "number", example: 2500, description: "Number of people" },
            },
        },
    }),
    __metadata("design:type", Array)
], AudienceStatDto.prototype, "hours", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Pre-calculated daily total for quick searches",
        example: 15000,
    }),
    __metadata("design:type", Number)
], AudienceStatDto.prototype, "daily_total", void 0);
/**
 * Display entity representing a digital display/screen in the system
 */
class DisplayEntity {
    /**
     * @deprecated
     */
    _id;
    id;
    display_id;
    name;
    description;
    /**
     * @deprecated
     */
    whitelist_categories;
    /**
     * @deprecated
     */
    blacklist_categories;
    /**
     * @deprecated
     */
    playlists_blocks;
    group;
    audience_stats;
    /**
     * @deprecated
     */
    ban_users;
    /**
     * @deprecated
     */
    muted_users;
    /**
     * @deprecated
     */
    moderators;
    /**
     * @deprecated
     */
    allowed_users;
    /**
     * @deprecated
     */
    allowed_senders;
    platform_provider;
    category;
    tags;
    categoryCircuitIds;
    restricted_access;
    restricted_send;
    linked;
    /**
     * @deprecated
     */
    live_comments;
    interior;
    /**
     * @deprecated
     */
    external;
    /**
     * @deprecated
     */
    ds;
    isMy;
    /**
     * @deprecated
     */
    display_tech_info;
    owner_screensaver;
    custom_screensaver;
    video_object_fit;
    image_object_fit;
    screensaver_duration;
    owner_watermark;
    custom_watermark;
    audio;
    autoaccept_media;
    no_interactive_mode;
    medias;
    /**
     * @deprecated
     */
    profile_picture;
    url_streetview;
    address;
    address_details;
    /**
     * @deprecated
     */
    slug;
    /**
     * @deprecated
     */
    show_viewers;
    /**
     * @deprecated
     */
    show_partners;
    /**
     * @deprecated
     */
    number_of_views;
    /**
     * @deprecated
     */
    chat_price;
    /**
     * @deprecated
     */
    gif_price;
    /**
     * @deprecated
     */
    advert_channel_price;
    fees;
    pegi;
    /** @deprecated Use audience_stats daily totals. */
    approximateDailyImpressions;
    pricing;
    ownerCampaignSlotsPaidQuantity;
    ownerCampaignSlotsPendingQuantity;
    ownerCampaignSlotsPendingDelta;
    ownerCampaignSlotsPendingUntil;
    ownerCampaignSlotsStatus;
    ownerCampaignSlotsValidUntil;
    programmaticPolicy;
    programmaticEligible;
    programmaticPlayerCapabilities;
    programmaticCapabilityLastSeenAt;
    ad_policies;
    /**
     * @deprecated
     */
    comments;
    owner;
    provider;
    display_time_zone;
    /**
     * @deprecated
     */
    start_active_time;
    /**
     * @deprecated
     */
    end_active_time;
    metadata;
    schedule;
    opacity_schedule;
    /**
     * @deprecated
     */
    ratings;
    stripe;
    screensaver_url;
    standard_price;
    standard_currency;
    /**
     * @deprecated
     */
    calendar;
    /**
     * @deprecated
     */
    is_live;
    private_only;
    /**
     * @deprecated
     */
    playList;
    send_restriction;
    is_archived;
    is_on;
    connection_observations;
    connection_expires_at;
    bucle_on;
    /**
     * @deprecated
     */
    issues;
    /**
     * @deprecated
     */
    status;
    asw_watermark;
    /**
     * @deprecated
     */
    dual_stream;
    /**
     * @deprecated
     */
    four_stream;
    /**
     * @deprecated
     */
    show_public_pay_movements;
    /**
     * @deprecated
     */
    desired_recaudation_amount;
    media_types;
    /**
     * @deprecated
     */
    live_comment_position;
    litle_player_position;
    /**
     * @deprecated
     */
    live_comment_config;
    show_qr_to_send_content;
    show_display_qr;
    show_media_qr;
    published;
    visible;
    widget;
    last_connection_at;
    connected_since_at;
    last_context_update;
    contextual_data;
    /**
     * @deprecated
     */
    update_at;
    /**
     * @deprecated
     */
    create_at;
    createdAt;
    updatedAt;
}
exports.DisplayEntity = DisplayEntity;
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Legacy id (deprecated)",
        deprecated: true,
        example: "507f1f77bcf86cd799439011",
    }),
    __metadata("design:type", String)
], DisplayEntity.prototype, "_id", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Unique identifier for the display",
        example: "507f1f77bcf86cd799439011",
    }),
    __metadata("design:type", String)
], DisplayEntity.prototype, "id", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Display identifier used for referencing",
        example: "display_abc123",
    }),
    __metadata("design:type", String)
], DisplayEntity.prototype, "display_id", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Human-readable name of the display",
        example: "Times Square Billboard",
    }),
    __metadata("design:type", String)
], DisplayEntity.prototype, "name", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Detailed description of the display",
        example: "Large LED billboard located in Times Square, New York",
    }),
    __metadata("design:type", String)
], DisplayEntity.prototype, "description", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "List of whitelisted category IDs (deprecated)",
        deprecated: true,
        type: [String],
        example: ["cat1", "cat2"],
    }),
    __metadata("design:type", Array)
], DisplayEntity.prototype, "whitelist_categories", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "List of blacklisted category IDs (deprecated)",
        deprecated: true,
        type: [String],
        example: ["cat3", "cat4"],
    }),
    __metadata("design:type", Array)
], DisplayEntity.prototype, "blacklist_categories", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "List of blocked playlist IDs (deprecated)",
        deprecated: true,
        type: [String],
        example: ["playlist1", "playlist2"],
    }),
    __metadata("design:type", Array)
], DisplayEntity.prototype, "playlists_blocks", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Display group entity if the display belongs to a group",
        type: display_group_entity_1.DisplayGroupEntity,
    }),
    __metadata("design:type", display_group_entity_1.DisplayGroupEntity)
], DisplayEntity.prototype, "group", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Audience statistics for the display",
        type: "array",
        items: {
            type: "object",
            properties: {
                day_of_week: { type: "number", example: 1 },
                hours: {
                    type: "array",
                    items: {
                        type: "object",
                        properties: {
                            start: { type: "number", example: 28800 },
                            end: { type: "number", example: 36000 },
                            count: { type: "number", example: 2500 },
                        },
                    },
                },
                daily_total: { type: "number", example: 15000 },
            },
        },
    }),
    __metadata("design:type", Array)
], DisplayEntity.prototype, "audience_stats", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "List of banned user IDs (deprecated)",
        deprecated: true,
        type: [String],
        example: ["user1", "user2"],
    }),
    __metadata("design:type", Array)
], DisplayEntity.prototype, "ban_users", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "List of muted user IDs (deprecated)",
        deprecated: true,
        type: [String],
        example: ["user3", "user4"],
    }),
    __metadata("design:type", Array)
], DisplayEntity.prototype, "muted_users", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "List of moderator user IDs (deprecated)",
        deprecated: true,
        type: [String],
        example: ["mod1", "mod2"],
    }),
    __metadata("design:type", Array)
], DisplayEntity.prototype, "moderators", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "List of allowed user IDs (deprecated)",
        deprecated: true,
        type: [String],
        example: ["user5", "user6"],
    }),
    __metadata("design:type", Array)
], DisplayEntity.prototype, "allowed_users", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "List of allowed sender IDs (deprecated)",
        deprecated: true,
        type: [String],
        example: ["sender1", "sender2"],
    }),
    __metadata("design:type", Array)
], DisplayEntity.prototype, "allowed_senders", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Service provider of the display device",
        example: "Broadsign",
    }),
    __metadata("design:type", String)
], DisplayEntity.prototype, "platform_provider", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Display category information",
        type: display_category_entity_1.DisplayCategoryEntity,
    }),
    __metadata("design:type", display_category_entity_1.DisplayCategoryEntity)
], DisplayEntity.prototype, "category", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Tags associated with the display",
        type: [tag_1.DisplayTagEntity],
    }),
    __metadata("design:type", Array)
], DisplayEntity.prototype, "tags", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Category circuit ids this display belongs to",
        type: [String],
    }),
    __metadata("design:type", Array)
], DisplayEntity.prototype, "categoryCircuitIds", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Whether the display has restricted access",
        example: false,
    }),
    __metadata("design:type", Boolean)
], DisplayEntity.prototype, "restricted_access", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Whether sending content to the display is restricted",
        example: false,
    }),
    __metadata("design:type", Boolean)
], DisplayEntity.prototype, "restricted_send", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Whether the display is linked to another system",
        example: true,
    }),
    __metadata("design:type", Boolean)
], DisplayEntity.prototype, "linked", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Whether live comments are enabled (deprecated)",
        deprecated: true,
        example: false,
    }),
    __metadata("design:type", Boolean)
], DisplayEntity.prototype, "live_comments", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Whether the display is located indoors",
        example: false,
    }),
    __metadata("design:type", Boolean)
], DisplayEntity.prototype, "interior", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Whether the display is located outdoors",
        example: true,
        deprecated: true,
    }),
    __metadata("design:type", Boolean)
], DisplayEntity.prototype, "external", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Digital signage flag (deprecated)",
        deprecated: true,
        example: false,
    }),
    __metadata("design:type", Boolean)
], DisplayEntity.prototype, "ds", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Whether this display belongs to the current user",
        example: true,
    }),
    __metadata("design:type", Boolean)
], DisplayEntity.prototype, "isMy", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Technical information about the display (deprecated)",
        deprecated: true,
        example: "LED 4K Resolution",
    }),
    __metadata("design:type", String)
], DisplayEntity.prototype, "display_tech_info", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "URL or identifier for the owner screensaver",
        example: "https://example.com/screensaver.mp4",
    }),
    __metadata("design:type", String)
], DisplayEntity.prototype, "owner_screensaver", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Whether a custom screensaver is enabled",
        example: true,
    }),
    __metadata("design:type", Boolean)
], DisplayEntity.prototype, "custom_screensaver", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "CSS object-fit property for video content",
        example: "cover",
        enum: ["fill", "contain", "cover", "none", "scale-down"],
    }),
    __metadata("design:type", String)
], DisplayEntity.prototype, "video_object_fit", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "CSS object-fit property for image content",
        example: "cover",
        enum: ["fill", "contain", "cover", "none", "scale-down"],
    }),
    __metadata("design:type", String)
], DisplayEntity.prototype, "image_object_fit", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Duration of screensaver in seconds",
        example: 300,
    }),
    __metadata("design:type", Number)
], DisplayEntity.prototype, "screensaver_duration", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "URL or identifier for the owner watermark",
        example: "https://example.com/watermark.png",
    }),
    __metadata("design:type", String)
], DisplayEntity.prototype, "owner_watermark", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Whether a custom watermark is enabled",
        example: false,
    }),
    __metadata("design:type", Boolean)
], DisplayEntity.prototype, "custom_watermark", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Whether audio is enabled on the display",
        example: true,
    }),
    __metadata("design:type", Boolean)
], DisplayEntity.prototype, "audio", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Whether media is automatically accepted without approval",
        example: false,
    }),
    __metadata("design:type", Boolean)
], DisplayEntity.prototype, "autoaccept_media", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Whether interactive mode is disabled",
        example: false,
    }),
    __metadata("design:type", Boolean)
], DisplayEntity.prototype, "no_interactive_mode", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Array of media files associated with the display",
        type: "array",
        items: {
            type: "object",
            properties: {
                url: { type: "string", example: "https://example.com/media.jpg" },
                type: { type: "string", enum: ["image", "video"], example: "image" },
            },
        },
    }),
    __metadata("design:type", Array)
], DisplayEntity.prototype, "medias", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Profile picture URL (deprecated)",
        deprecated: true,
        example: "https://example.com/profile.jpg",
    }),
    __metadata("design:type", String)
], DisplayEntity.prototype, "profile_picture", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Google Street View URL for the display location",
        example: "https://maps.google.com/streetview?cbll=40.7589,-73.9851",
    }),
    __metadata("design:type", String)
], DisplayEntity.prototype, "url_streetview", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Formatted postal address resolved from the display coordinates",
        example: "Calle Mayor 1, 28013 Madrid, Spain",
    }),
    __metadata("design:type", String)
], DisplayEntity.prototype, "address", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Structured postal address for display onboarding",
        type: "object",
        properties: {
            address_line_1: { type: "string", example: "Calle Mayor 1" },
            address_line_2: { type: "string", example: "Floor 2" },
            postal_code: { type: "string", example: "28013" },
            city: { type: "string", example: "Madrid" },
            state_region: { type: "string", example: "Madrid" },
            country: { type: "string", example: "ES" },
        },
    }),
    __metadata("design:type", Object)
], DisplayEntity.prototype, "address_details", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "URL slug for the display (deprecated)",
        deprecated: true,
        example: "times-square-billboard",
    }),
    __metadata("design:type", String)
], DisplayEntity.prototype, "slug", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Whether to show viewer count (deprecated)",
        deprecated: true,
        example: false,
    }),
    __metadata("design:type", Boolean)
], DisplayEntity.prototype, "show_viewers", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Whether to show partners (deprecated)",
        deprecated: true,
        example: false,
    }),
    __metadata("design:type", Boolean)
], DisplayEntity.prototype, "show_partners", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Number of views (deprecated)",
        deprecated: true,
        example: 1500,
    }),
    __metadata("design:type", Number)
], DisplayEntity.prototype, "number_of_views", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Chat pricing information (deprecated)",
        deprecated: true,
        type: "object",
        properties: {
            amount: { type: "number", example: 0.5 },
            currency: { type: "string", example: "USD" },
        },
    }),
    __metadata("design:type", Object)
], DisplayEntity.prototype, "chat_price", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "GIF pricing information (deprecated)",
        deprecated: true,
        type: "object",
        properties: {
            amount: { type: "number", example: 1.0 },
            currency: { type: "string", example: "USD" },
        },
    }),
    __metadata("design:type", Object)
], DisplayEntity.prototype, "gif_price", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Advertisement channel pricing (deprecated)",
        deprecated: true,
        type: "object",
        properties: {
            amount: { type: "number", example: 5.0 },
            currency: { type: "string", example: "USD" },
        },
    }),
    __metadata("design:type", Object)
], DisplayEntity.prototype, "advert_channel_price", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Fee structure for the display",
        type: "object",
        properties: {
            displayOwner: {
                type: "number",
                example: 0.15,
                description: "Commission percentage for display owner",
            },
        },
    }),
    __metadata("design:type", Object)
], DisplayEntity.prototype, "fees", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "PEGI content rating information",
        type: "object",
        properties: {
            adult: { type: "boolean", example: false },
            offensive: { type: "boolean", example: false },
            sex: { type: "boolean", example: false },
            violence: { type: "boolean", example: false },
        },
    }),
    __metadata("design:type", Object)
], DisplayEntity.prototype, "pegi", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Deprecated audience fallback used only when daily audience is unavailable",
        deprecated: true,
        type: "object",
        properties: {
            min: { type: "number", example: 1000 },
            max: { type: "number", example: 5000 },
            average: { type: "number", example: 3000 },
        },
    })
    /** @deprecated Use audience_stats daily totals. */
    ,
    __metadata("design:type", Object)
], DisplayEntity.prototype, "approximateDailyImpressions", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Pricing details for the display",
        type: dto_1.DisplayPricingDto,
    }),
    __metadata("design:type", Object)
], DisplayEntity.prototype, "pricing", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Paid extra owner-campaign slots enabled for this display playback loop",
        default: 0,
        minimum: 0,
        example: 2,
    }),
    __metadata("design:type", Number)
], DisplayEntity.prototype, "ownerCampaignSlotsPaidQuantity", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Pending owner-campaign slot quantity that will replace the active paid quantity at the next period",
        default: 0,
        minimum: 0,
        example: 1,
    }),
    __metadata("design:type", Number)
], DisplayEntity.prototype, "ownerCampaignSlotsPendingQuantity", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Delta for owner-campaign slots pending to apply at the scheduled date. Negative means cancel, positive means add.",
        example: -2,
    }),
    __metadata("design:type", Number)
], DisplayEntity.prototype, "ownerCampaignSlotsPendingDelta", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Date when the pending owner-campaign slot quantity takes effect",
        type: Date,
    }),
    __metadata("design:type", Date)
], DisplayEntity.prototype, "ownerCampaignSlotsPendingUntil", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Lifecycle status for the paid owner-campaign slot entitlement",
        enum: ["active", "inactive", "canceled", "expired"],
        example: "active",
    }),
    __metadata("design:type", String)
], DisplayEntity.prototype, "ownerCampaignSlotsStatus", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Expiration boundary for the current paid owner-campaign slot entitlement",
        type: Date,
    }),
    __metadata("design:type", Date)
], DisplayEntity.prototype, "ownerCampaignSlotsValidUntil", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Owner-controlled programmatic inventory policy; absent values are disabled",
    }),
    __metadata("design:type", Object)
], DisplayEntity.prototype, "programmaticPolicy", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Administrative eligibility for programmatic delivery",
        default: false,
    }),
    __metadata("design:type", Boolean)
], DisplayEntity.prototype, "programmaticEligible", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Player capabilities most recently observed by the server",
        type: [String],
    }),
    __metadata("design:type", Array)
], DisplayEntity.prototype, "programmaticPlayerCapabilities", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Timestamp of the latest server-observed programmatic player capability",
        type: Date,
    }),
    __metadata("design:type", Date)
], DisplayEntity.prototype, "programmaticCapabilityLastSeenAt", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Advertising policies for the display",
    }),
    __metadata("design:type", Object)
], DisplayEntity.prototype, "ad_policies", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Comments array (deprecated)",
        deprecated: true,
        type: [String],
        example: ["comment1", "comment2"],
    }),
    __metadata("design:type", Array)
], DisplayEntity.prototype, "comments", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Display owner information",
        type: user_entity_1.UserEntity,
    }),
    __metadata("design:type", user_entity_1.UserEntity)
], DisplayEntity.prototype, "owner", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Display provider information",
        type: user_entity_1.UserEntity,
    }),
    __metadata("design:type", user_entity_1.UserEntity)
], DisplayEntity.prototype, "provider", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Display timezone",
        example: "America/New_York",
    }),
    __metadata("design:type", String)
], DisplayEntity.prototype, "display_time_zone", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Start active time (deprecated)",
        deprecated: true,
        example: "09:00",
    }),
    __metadata("design:type", String)
], DisplayEntity.prototype, "start_active_time", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "End active time (deprecated)",
        deprecated: true,
        example: "22:00",
    }),
    __metadata("design:type", String)
], DisplayEntity.prototype, "end_active_time", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Display metadata including location and technical specs",
    }),
    __metadata("design:type", types_1.DisplayMetadata)
], DisplayEntity.prototype, "metadata", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Display schedule configuration",
        type: types_1.DisplaySchedule,
    }),
    __metadata("design:type", types_1.DisplaySchedule)
], DisplayEntity.prototype, "schedule", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Display opacity schedule configuration",
        type: types_1.DisplayOpacitySchedule,
    }),
    __metadata("design:type", types_1.DisplayOpacitySchedule)
], DisplayEntity.prototype, "opacity_schedule", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Display ratings (deprecated)",
        deprecated: true,
        type: "array",
        items: {
            type: "object",
            properties: {
                owner: { type: "string", example: "user123" },
                score: { type: "number", example: 4.5 },
            },
        },
    }),
    __metadata("design:type", Array)
], DisplayEntity.prototype, "ratings", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "URL for the screensaver content",
        example: "https://example.com/screensaver.mp4",
    }),
    __metadata("design:type", String)
], DisplayEntity.prototype, "screensaver_url", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Standard price for content display",
        example: 10.99,
    }),
    __metadata("design:type", Number)
], DisplayEntity.prototype, "standard_price", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Currency for standard pricing",
        example: "USD",
    }),
    __metadata("design:type", String)
], DisplayEntity.prototype, "standard_currency", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Calendar events (deprecated)",
        deprecated: true,
        type: "array",
        items: { type: "object" },
    }),
    __metadata("design:type", Array)
], DisplayEntity.prototype, "calendar", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Whether the display is live (deprecated)",
        deprecated: true,
        example: false,
    }),
    __metadata("design:type", Boolean)
], DisplayEntity.prototype, "is_live", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Whether the display is private only",
        example: false,
    }),
    __metadata("design:type", Boolean)
], DisplayEntity.prototype, "private_only", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Playlist IDs (deprecated)",
        deprecated: true,
        type: [String],
        example: ["playlist1", "playlist2"],
    }),
    __metadata("design:type", Array)
], DisplayEntity.prototype, "playList", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Restriction on sending content to the display",
    }),
    __metadata("design:type", String)
], DisplayEntity.prototype, "send_restriction", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Whether the display is archived",
        example: false,
    }),
    __metadata("design:type", Boolean)
], DisplayEntity.prototype, "is_archived", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Whether the display is currently on/active",
        example: true,
    }),
    __metadata("design:type", Boolean)
], DisplayEntity.prototype, "is_on", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Whether loop mode is enabled",
        example: false,
    }),
    __metadata("design:type", Boolean)
], DisplayEntity.prototype, "bucle_on", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Technical issues (deprecated)",
        deprecated: true,
        type: "array",
        items: { type: "object" },
    }),
    __metadata("design:type", Array)
], DisplayEntity.prototype, "issues", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Status information (deprecated)",
        deprecated: true,
        type: "array",
        items: { type: "object" },
    }),
    __metadata("design:type", Array)
], DisplayEntity.prototype, "status", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Whether ASW watermark is enabled",
        example: false,
    }),
    __metadata("design:type", Boolean)
], DisplayEntity.prototype, "asw_watermark", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Dual stream support (deprecated)",
        deprecated: true,
        example: false,
    }),
    __metadata("design:type", Boolean)
], DisplayEntity.prototype, "dual_stream", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Four stream support (deprecated)",
        deprecated: true,
        example: false,
    }),
    __metadata("design:type", Boolean)
], DisplayEntity.prototype, "four_stream", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Show public payment movements (deprecated)",
        deprecated: true,
        example: false,
    }),
    __metadata("design:type", Boolean)
], DisplayEntity.prototype, "show_public_pay_movements", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Desired revenue amount (deprecated)",
        deprecated: true,
        example: 1000,
    }),
    __metadata("design:type", Number)
], DisplayEntity.prototype, "desired_recaudation_amount", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Supported media types for the display",
        type: "array",
        items: { type: "string" },
        example: ["image", "video", "gif"],
    }),
    __metadata("design:type", Array)
], DisplayEntity.prototype, "media_types", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Live comment position (deprecated)",
        deprecated: true,
        example: "bottom",
    }),
    __metadata("design:type", String)
], DisplayEntity.prototype, "live_comment_position", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Little player position orientation",
        enum: ["rotate-90", "rotate-270", "horizontal"],
        example: "horizontal",
    }),
    __metadata("design:type", String)
], DisplayEntity.prototype, "litle_player_position", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Live comment configuration (deprecated)",
        deprecated: true,
    }),
    __metadata("design:type", Object)
], DisplayEntity.prototype, "live_comment_config", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Whether to show QR code for sending content",
        example: true,
    }),
    __metadata("design:type", Boolean)
], DisplayEntity.prototype, "show_qr_to_send_content", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Whether to show the display QR code",
        example: true,
    }),
    __metadata("design:type", Boolean)
], DisplayEntity.prototype, "show_display_qr", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Whether to show media QR codes",
        example: true,
    }),
    __metadata("design:type", Boolean)
], DisplayEntity.prototype, "show_media_qr", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Whether the display is published",
        example: true,
    }),
    __metadata("design:type", Boolean)
], DisplayEntity.prototype, "published", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Whether the display is visible",
        example: true,
    }),
    __metadata("design:type", Boolean)
], DisplayEntity.prototype, "visible", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Widget configuration for the display",
        type: "object",
        properties: {
            kind: { type: "string", enum: ["url"], example: "url" },
            config: {
                type: "object",
                properties: {
                    autoHide: { type: "boolean", example: false },
                    isInteractive: { type: "boolean", example: true },
                    position: {
                        type: "string",
                        enum: ["top", "bottom", "left", "right"],
                        example: "bottom",
                    },
                    widthPercent: { type: "number", example: 50 },
                    url: {
                        type: "string",
                        example: "https://example.com/widget",
                        required: false,
                    },
                },
            },
        },
    }),
    __metadata("design:type", Object)
], DisplayEntity.prototype, "widget", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Last connection timestamp",
        type: "string",
        format: "date-time",
        example: "2024-01-15T10:30:00Z",
    }),
    __metadata("design:type", Date)
], DisplayEntity.prototype, "last_connection_at", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Timestamp when the current online session started",
        type: "string",
        format: "date-time",
        nullable: true,
        example: "2024-01-15T09:00:00Z",
    }),
    __metadata("design:type", Object)
], DisplayEntity.prototype, "connected_since_at", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Timestamp of the last contextual data update",
        example: "2024-01-15T10:30:00Z",
    }),
    __metadata("design:type", Object)
], DisplayEntity.prototype, "last_context_update", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Contextual data related to the display",
        type: "object",
        properties: {
            scoring: {
                type: "object",
                properties: {
                    total_score: { type: "number", example: 85 },
                    commercial_score: { type: "number", example: 90 },
                    transit_score: { type: "number", example: 80 },
                    last_calculated: { type: "string", format: "date-time", example: "2024-01-15T10:30:00Z" },
                },
            },
            services: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        name: { type: "string", example: "Coffee Shop" },
                        category: { type: "string", example: "catering" },
                        distance_meters: { type: "number", example: 150 },
                    },
                },
            },
        },
    }),
    __metadata("design:type", Object)
], DisplayEntity.prototype, "contextual_data", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Update timestamp (deprecated)",
        deprecated: true,
        type: "string",
        format: "date-time",
    }),
    __metadata("design:type", Date)
], DisplayEntity.prototype, "update_at", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Creation timestamp (deprecated)",
        deprecated: true,
        type: "string",
        format: "date-time",
    }),
    __metadata("design:type", Date)
], DisplayEntity.prototype, "create_at", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Creation timestamp",
        example: "2024-01-15T10:30:00Z",
    }),
    __metadata("design:type", String)
], DisplayEntity.prototype, "createdAt", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Last update timestamp",
        example: "2024-01-15T10:30:00Z",
    }),
    __metadata("design:type", String)
], DisplayEntity.prototype, "updatedAt", void 0);
